module.exports = function (getRestrictions, value) {
  var initialValue = value;
  var restrictions = getRestrictions('numeric');

  if (restrictions.length) {
    if (isNaN(value)) {
      throw {
        message: 'number_nan',
        params: _.extend({ value: initialValue })
      };
    }

    value = parseFloat(value);
    for (var i in restrictions) {
      if (restrictions[i].max < value || restrictions[i].min > value) {
        throw {
          message: 'number_out_of_range',
          params: _.extend({ value: initialValue }, restrictions[i])
        };
      }
    }
  }

  return value.toString();
};
